import { Grid, withStyles } from '@material-ui/core';
import React from 'react';
import { withRouter } from 'react-router-dom';
import CandidateMenu from '../../../candidateMenu/CandidateMenu';
import CandidateDetailsHeaderCard from '../CandidateDetailsHeaderCard';
import CandidatePersonalCard from '../CandidatePersonalCard';
import { styles } from './CandidatePersonalDetailsContent.styles';

const CandidatePersonalDetailsContent = ({
  candidateDetails,
  classes,
  currentUser,
}) => {
  const isSelfEdit = currentUser.id === candidateDetails.id;

  return (
    <Grid container className={classes.wrapper}>
      <CandidateMenu
        itemSelected="personal-data"
        title={'candidateDetails:anonymousDetailsCard:menuTitle'}
        subtitle={'candidateDetails:anonymousDetailsCard:subTitle'}
        currentCandidate={candidateDetails}
        currentUser={currentUser}
      />
      <CandidateDetailsHeaderCard
        itemSelected="personal-data"
        title={
          isSelfEdit
            ? 'candidateDetails:personalDetailsContent:headerMenuTitleSelfEdit'
            : 'candidateDetails:personalDetailsContent:headerMenuTitle'
        }
        candidate={candidateDetails}
        currentUser={currentUser}
      />
      <CandidatePersonalCard
        candidate={candidateDetails}
        currentUser={currentUser}
      />
    </Grid>
  );
};

export default withStyles(styles)(withRouter(CandidatePersonalDetailsContent));
